import axios from 'axios';

export function trackBlueSkyShare(name: string, slug: string) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'Twitter'
        });
    }
    axios.patch(`/petitions/${slug}/share/bluesky`);
}

export function copyToClipboard(name: string, slug: string, str: string) {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'Copy'
        });
    }
    axios.patch(`/petitions/${slug}/share/copy`);
}

export function trackEmailShare(name: string, slug: string) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'Email'
        });
    }
    axios.patch(`/petitions/${slug}/share/email`);
}

export function trackFBShare(name: string, slug: string) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'Facebook'
        });
    }
    axios.patch(`/petitions/${slug}/share/facebook`);
}

export function trackTwitterShare(name: string, slug: string) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'Twitter'
        });
    }
    axios.patch(`/petitions/${slug}/share/twitter`);
}

export function trackWhatsAppShare(name: string, slug: string) {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'share', {
            content_type: 'petition',
            item_id: name,
            method: 'WhatsApp'
        });
    }
    axios.patch(`/petitions/${slug}/share/whatsapp`);
}
